import React from 'react';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import Unit from './Unit';

function UnitIndex() {
  return (
    <SearchMenu>
      <FilterConsumer>{({ agencies }) => <Unit filter={agencies} />}</FilterConsumer>
    </SearchMenu>
  );
}

export default UnitIndex;
